import { useMemo } from 'react'

import { useAppSelector } from 'hooks/reduxHooks'
import getOfferListKey from 'lib/offer/offerListKey'

export interface Options {
  disabled?: boolean
}

function useStreamSearchExpired(
  filters: App.OfferListFilters | undefined,
  options: Options = {},
): boolean {
  const disabled = options.disabled || !filters

  const listKey = useMemo(() => {
    if (filters) {
      return getOfferListKey(filters)
    }
    return ''
  }, [filters])

  const error = useAppSelector(state => state.offer.offerLists[listKey]?.error) ?? undefined

  if (disabled) {
    return false
  }

  return error === 'searchNotFound'
}

export default useStreamSearchExpired
